module.exports = __webpack_public_path__ + "static/media/redCross.b921753f.png";